import clsx from "clsx";
import { FC, ReactNode } from "react";
import ActiveStep from "../../assets/icons/active-step.svg?react";
import InactiveStep from "../../assets/icons/inactive-step.svg?react";
import CompletedStep from "../../assets/icons/completed-step.svg?react";

interface StyledStepperProps {
  stepsContent: ReactNode[];
  activeStep: number;
}

interface StepIconProps {
  active: boolean;
  completed: boolean;
}

const StepIcon: FC<StepIconProps> = ({ active, completed }) => {
  return <>{active ? <ActiveStep /> : completed ? <CompletedStep /> : <InactiveStep />}</>;
};

const StyledStepper: FC<StyledStepperProps> = ({ stepsContent, activeStep }) => {
  return (
    <ol className="relative">
      {stepsContent.map((content, index) => {
        return (
          <li
            key={index}
            className={clsx("ps-6 pb-10", {
              "border-gray-200": index !== stepsContent.length - 1,
              "border-s": index !== stepsContent.length - 1,
              "border-blue-600!": index !== stepsContent.length - 1 && activeStep > index,
            })}
          >
            <span className="absolute -start-4 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-4 ring-gray-50">
              <StepIcon active={index === activeStep} completed={index < activeStep} />
            </span>
            {content}
          </li>
        );
      })}
    </ol>
  );
};

export default StyledStepper;
